module.exports = __webpack_public_path__ + "img/fpsc.cbe8c2e6.png";